import React from 'react';
import PropTypes from 'prop-types';
import { isValid, isText, decodeSpecialCharacters, getRelValue } from '../../../../utils';
import * as cheerio from 'cheerio';

const ShoppableStorefrontProduct = ({ product, isMobile, isWowShop }) => {
  const {
    brand,
    superlative,
    productImage,
    productCopy,
    button,
    saleSticker,
  } = product;
  if (!isValid(product)) {
    return null;
  }

  const imageUrl = isValid(productImage) ? productImage : null;
  const decodedBrandName = isValid(brand) ? decodeSpecialCharacters(brand) : null;
  const decodedProductCopy = isValid(productCopy) ? decodeSpecialCharacters(productCopy) : null;

  const hasSaleSticker = isText(saleSticker);
  const renderedSaleSticker = (
    <div className='sale-sticker-wrapper'>
      <div className='sale-sticker-text'>{saleSticker}</div>
    </div>
  );

  let productButton = isValid(button) ? button : null;
  productButton = isValid(productButton) ? decodeSpecialCharacters(productButton) : null;
  let buttonText = isValid(productButton) ? productButton : `Buy at ${decodedBrandName}`;

  if (buttonText.includes('<a')) {
    const $ = cheerio.load(buttonText);
    const element = $('a');
    $('a').attr('target', '_blank');
    const target = $('a').attr('target');
    buttonText = $.html(element[0]);
    const href = $('a').attr('href');
    const buttonRel = getRelValue(href);
    $('a').attr('rel', buttonRel);
    if (buttonText.includes('<p>')) {
      buttonText = buttonText.replace(/<p>/g, '');
    }
    if (buttonText.includes('</p>')) {
      buttonText = buttonText.replace(/<\/p>/g, '');
    }
    if (buttonText.includes('<s>')) {
      buttonText = buttonText.replace(/<s>/g, '<s style="font-weight:200;">');
    }
    if (buttonText.includes('|')) {
      buttonText = buttonText.replace(/\|/g, '<span style="font-weight:200;">|</span>');
    }
  }

  const finalButton = buttonText && (
    <div
      className="price-button"
      dangerouslySetInnerHTML={{ __html: buttonText }}
    ></div>
  );

  const getProductUrl = () => {
    const $ = cheerio.load(buttonText);
    const href = $('a').attr('href');
    return href;
  };

  const getProductRel = () => {
    const $ = cheerio.load(buttonText);
    const rel = $('a').attr('rel');
    return rel;
  }

  const renderedBrand = isWowShop ? (
    <a className="product-brand-link" href={getProductUrl()} target="_blank" rel={getProductRel()}>
      <h3 className="product-brand">{decodedBrandName}</h3>
    </a>
  ) : (
    <h3 className="product-brand">{decodedBrandName}</h3>
  );

  return (
    <div className="product">
      <a className="product-image-link" href={getProductUrl()} target="_blank" rel={getProductRel()}>
        <img className="product-image" src={imageUrl}></img>
        {hasSaleSticker && renderedSaleSticker}
      </a>

      <div className="product-info">
        <p className="product-superlative">{superlative}</p>
        {renderedBrand}
        <p className='product-copy'>{decodedProductCopy}</p>
      </div>
        {finalButton}
    </div>
  );
};

ShoppableStorefrontProduct.propTypes = {
  data: PropTypes.array,
};

export default ShoppableStorefrontProduct;
